export default __webpack_public_path__ + "static/media/signin.816d7d33.png";